<script>
  import Tooltip from '@/components/Tooltip';

  export default {
    components: { Tooltip },
    model: {
      prop: 'currentValue',
      event: 'change'
    },
    props: {
      currentValue: {
        type: [String, Boolean, Number],
        default: ''
      },
      value: {
        type: [String, Boolean, Number],
        default: ''
      },
      id: {
        type: String,
        required: true
      },
      icon: {
        type: String,
        default: 'radio'
      },
      iconClasses: {
        type: String,
        default: 'text-xs'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      tooltip: {
        type: String,
        default: ''
      },
      required: {
        type: Boolean,
        default: false
      },
      name: {
        type: String,
        default: ''
      }
    },
    setup (props, { emit }) {
      const handleEmit = (e) => {
        emit('change', props.value);
      };

      return {
        handleEmit
      };
    }
  }

</script>

<template>
  <span
    class="e-radio"
    :class="{ 'is-disabled': disabled }"
  >
    <input
      :id="id"
      type="radio"
      :value="value"
      :checked="value === currentValue"
      :disabled="disabled"
      class="radio"
      :name="name"
      @change="handleEmit"
    >
    <label
      class="radio-label cursor-pointer min-w-30"
      :for="id"
    >
      <span
        v-if="!required"
        class="radio-icon"
      >
        <q-icon
          :name="icon"
          :class="iconClasses"
        />
      </span>
      <slot />
      <span
        v-if="tooltip && required"
        class="info hidden lg:block absolute top-2 left-2 z-10 text-blue-500"
      >
        <q-icon
          name="info"
          class="text-base"
        />
        <div class="tooltip hidden">
          <tooltip :text="tooltip" />
        </div>
      </span>

    </label>
  </span>
</template>

<style lang="scss">
.e-radio {
  @apply inline-block;

  input[type="radio"] {
    @apply absolute w-0 h-0 opacity-0;
  }

  &:hover:not(.is-disabled) {
    .radio-icon {
      @apply border-black;
    }
  }

  .radio-label {
    @apply inline-flex items-center;
  }

  .radio-icon {
    @apply flex rounded-full items-center justify-center w-6 h-6 flex-grow-0 bg-white text-gray-200 border-2 mr-3;

    .q-icon {
      @apply flex;

      svg {
        width: 1em;
        height: 1em;

        path {
          fill: currentColor;
        }

      }

    }

    svg {
      opacity: 0;
      transform: scale(0.5);
      transition: transform 0.2s cubic-bezier(0.390, 0.575, 0.565, 1.000), opacity 0.2s cubic-bezier(0.390, 0.575, 0.565, 1.000);
    }

  }

  .radio:disabled+label {
    @apply cursor-not-allowed;
  }

  .radio:checked:not(:disabled)+label .radio-icon {
    @apply border-black text-black;

    svg {
      opacity: 1;
      transform: scale(1);
    }

  }

  .radio:checked:disabled+label .radio-icon {
    @apply border-gray-200;

    svg {
      opacity: 1;
      transform: scale(1);
    }

  }

  .radio:focus+label .radio-icon {
    // box-shadow: 0 0 0 0.125rem theme('colors.orange.500');
  }

  .info:hover .tooltip {
    display: block;
  }

}

.e-radio.is-disabled {
  @apply text-gray-200;
  user-select: none;

  .radio-icon {
    @apply border-gray-200;
  }

  .radio-label:hover .radio-icon {}

}
</style>
